/**
 * Transport for the map surfaces (the operations dashboard's map and the
 * marker hover card). Redux-backed dashboard reads (the summary panels) stay
 * in slice.js.
 */
import apiClient from '@sophocles/http-common';

export const fetchDashboardMapSites = params => apiClient.get('/dashboard/map/', { params }).then(res => res.data);

export const fetchDashboardMapSiteDetail = (siteId, config) =>
  apiClient.get(`/dashboard/map/site/${siteId}/`, config).then(res => res.data);

// Generic odl-app list-page fetch used by the operations dashboard's CSV
// export (basePath varies by active tab — alarms vs repairs).
export const fetchResourcePage = (basePath, params) =>
  apiClient.get(`/odl-app/${basePath}/`, { params }).then(res => res.data);
